import React from 'react';
import {useWindowDimensions, View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {BBBBannerProgressBar} from '/component/base/BonusProgressBar/BBBBannerProgressBar/BBBBannerProgressBar';
import {BBBProfileCardProgressBar} from '/component/base/BonusProgressBar/BBBProfileCardProgressBar';
import Text from '/component/base/Text';
import {DashboardID} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesBannerText} from '/redux/selector/remoteConfig.selector';
import testProperties from '/util/testing/testProperties';

import {styles} from './BusinessBuilderBonusBanner.style';
import {generateOnLearnMore} from './BusinessBuilderBonusBanner.util';
interface BusinessBuilderBonusBannerProps {
  title: string;
  isBanner: boolean;
  isBBBProfileCard: boolean;
  popoverShow: () => void;
  currentScreen: string;
  handleBannerHeight: (event: any) => void;
  bannerHeight: number | null;
  cardNumber: number | null;
  totalCards: number | null;
  businessBuilderBonusFQV: any;
  businessBuilderBonusCoachesCount: number;
  businessBuilderBonusCurrentDate: string | null;
  BBBonusContributorCurrentDate: string | null;
  BBBonusContributors: any[];
  BBBonusContributorActivationDate: string | null;
  lastPaidRank: string;
}

export const BusinessBuilderBonusBanner: React.FC<
  BusinessBuilderBonusBannerProps
> = ({
  title = '',
  isBanner = false,
  isBBBProfileCard = false,
  popoverShow = () => {},
  currentScreen = '',
  handleBannerHeight = () => {},
  bannerHeight = null,
  cardNumber = null,
  totalCards = null,
  businessBuilderBonusFQV = '',
  businessBuilderBonusCoachesCount = 0,
  businessBuilderBonusCurrentDate = null,
  BBBonusContributorCurrentDate = null,
  BBBonusContributors = [],
  BBBonusContributorActivationDate = null,
  lastPaidRank = '',
}) => {
  const {fontScale} = useWindowDimensions();
  const isLargeFont = fontScale > 1.15;
  const {tt} = useTranslation('BusinessBuilderBonusBanner');
  const featureFlagBannerText = useSelector(variablesBannerText);
  const bbbText = get(featureFlagBannerText, 'BBBText', '');

  const onLearnMoreClick = () =>
    generateOnLearnMore({popoverShow, currentScreen});

  const renderDescription = () => {
    return tt('content', () => (
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        {...testProperties(DashboardID.bbBannerDescription)}>
        {bbbText}{' '}
        {tt('learnMore', () => (
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            onPress={onLearnMoreClick()}
            style={styles.link}
            {...testProperties(DashboardID.bbBannerLearnMoreLink)}>
            Learn more
          </Text>
        ))}
      </Text>
    ));
  };

  return (
    <View
      style={{
        ...(isBanner ? styles.BBBContent : styles.profileCardContent),
        ...(isBanner && bannerHeight ? {minHeight: bannerHeight} : {}),
      }}
      onLayout={handleBannerHeight}
      {...testProperties(DashboardID.bbBanner)}>
      <View
        style={[
          styles.headerContainer,
          isLargeFont && styles.headerContainerLargeFont,
        ]}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="heading"
          style={styles.headerText}
          {...testProperties(DashboardID.bbBannerTitle)}>
          {tt('heading', title)}
        </Text>
        {totalCards &&
          cardNumber &&
          tt('sideTitle', () => (
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              key="side-title"
              variant="button"
              style={[styles.sideText, isLargeFont && styles.sideTextLargeFont]}
              {...testProperties(DashboardID.bbBannerSideTitle)}>
              {cardNumber} of {totalCards}
            </Text>
          ))}
      </View>
      {renderDescription()}
      <View style={styles.divider} />
      <BBBBannerProgressBar
        businessBuliderCoachesCount={businessBuilderBonusCoachesCount}
        currentDate={businessBuilderBonusCurrentDate || ''}
        fqv={businessBuilderBonusFQV}
        isBanner={true}
        lastPaidRank={lastPaidRank}
      />

      {isBBBProfileCard && (
        <BBBProfileCardProgressBar
          currentDate={BBBonusContributorCurrentDate || ''}
          BBBonusContributors={BBBonusContributors}
          activationDate={BBBonusContributorActivationDate || ''}
        />
      )}
    </View>
  );
};
